/**
 * Header — the v1 green band that sits above every page.
 *
 * Its controls now live in shared/GlobalControls (rendered here on the dark
 * ground, and in PageChrome's sticky row on the light one). This file is what
 * remains: the band itself, plus the v2 kill switch.
 *
 * v1 renders EXACTLY as it always has. The v2 "clean-slate" chrome (the row
 * grammar built in PageChrome.tsx; see docs/chrome-v2-rollout.md for the design
 * lineage — the earlier chrome-onebar-hifi.html is superseded) deletes this
 * band and moves its controls to the Sidebar — so when the flag is on, this
 * component renders nothing and the Sidebar + PageChrome own the chrome.
 * Self-hiding here rather than branching in Layout keeps the flag's blast
 * radius to the two components that actually differ.
 */
import { useAuthStore } from '../store/useAuthStore';
import { isChromeV2 } from '../lib/chromeV2';
import GlobalControls from './shared/GlobalControls';
import AddDataMenu from './AddDataMenu';

export default function Header() {
  const { org } = useAuthStore();

  // One bar: PageChrome renders the controls in its sticky row, and this band
  // would be the second bar the design exists to remove.
  if (isChromeV2()) return null;

  return (
    <header className="bg-brand-primary-dark shadow-sm px-6 py-3 flex items-center justify-between shrink-0">
      {/* Left — global Add-data entry */}
      <div className="flex items-center gap-2.5">
        <AddDataMenu />
      </div>
      {/* org is v1-only: in the one bar it moves under the Avium logo in the
          sidebar, because it is identity rather than a page tool (Brian). */}
      <GlobalControls variant="dark" showOrg={!!org} />
    </header>
  );
}
